import i18next from 'i18next';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import { formatNumberForExport } from '../../common/utils';
import { makeXLS } from '@commons/utils/makeXLS';

export const generateExport = (globalTableData, currentPeriod, previousPeriod, storeName) => {
  // Prepare headers
  const headers = [
    i18next.t('GENERAL.STORE'),
    `${i18next.t('ANALYSIS.PERFORMANCE.TICKETS')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.TICKETS')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
    `${i18next.t('GENERAL.TURNOVER_EX_TAX')} (${i18next.t('ANALYSIS.PERFORMANCE.CURRENT_PERIOD')})`,
    `${i18next.t('GENERAL.TURNOVER_EX_TAX')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.AVERAGE_TICKET')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.AVERAGE_TICKET')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.REAL_FOOD_CONSUMPTION_SHORT')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.REAL_FOOD_CONSUMPTION_SHORT')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.REAL_FOOD_CONSUMPTION_RATIO_SHORT')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.CURRENT_PERIOD',
    )})`,
    `${i18next.t('ANALYSIS.PERFORMANCE.REAL_FOOD_CONSUMPTION_RATIO_SHORT')} (${i18next.t(
      'ANALYSIS.PERFORMANCE.PREVIOUS_PERIOD',
    )})`,
  ];

  // Prepare data rows
  const data = globalTableData.map((row) => [
    row.storeName,
    formatNumberForExport(row.tickets?.current),
    formatNumberForExport(row.tickets?.previous),
    formatNumberForExport(row.turnoverExcludingTaxes?.current),
    formatNumberForExport(row.turnoverExcludingTaxes?.previous),
    formatNumberForExport(row.averageTicket?.current),
    formatNumberForExport(row.averageTicket?.previous),
    formatNumberForExport(row.realFoodConsumption?.current),
    formatNumberForExport(row.realFoodConsumption?.previous),
    formatNumberForExport(row.realFoodConsumptionRatio?.current),
    formatNumberForExport(row.realFoodConsumptionRatio?.previous),
  ]);

  // Create sheet
  const sheet = {
    title: i18next.t('ANALYSIS.PERFORMANCE.GLOBAL_GRID_TITLE', { storeName }),
    headers,
    data,
  };

  // Generate Excel file
  const fileName = `${i18next.t('ANALYSIS.PERFORMANCE.GLOBAL_GRID_TITLE', {
    storeName,
  })} - ${currentPeriod.startDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} - ${currentPeriod.endDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} VS ${previousPeriod.startDate.format(
    DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR,
  )} - ${previousPeriod.endDate.format(DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR)}`;
  makeXLS(fileName, [sheet]);
};
